import { ReactElement, useContext } from "react"

import {
    NON_SYS_ADMIN_STEPS,
    SYS_ADMIN_STEPS,
} from "../../../../../constants/ttr/registerDevice"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { CreateDeviceContext } from "../../providers/baseProviders/createDeviceProvider"

/** AppStepper with labels specific to the TTR publish device form.
 * Will not display manufacturer page if user is not a sys admin
 */
const CreateDeviceProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer } =
        useContext(CreateDeviceContext)

    const steps = canEditManufacturer
        ? [...SYS_ADMIN_STEPS, ...NON_SYS_ADMIN_STEPS]
        : NON_SYS_ADMIN_STEPS

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateDeviceProgressStepper
